<div #menuEl class="row-context-menu" role="menu"
  [id]="menuId"
  [attr.aria-label]="'Row ' + (rowIndex + 1) + ' actions'"
  (keydown.escape)="close.emit()" (keydown)="onKeydown($event)">
  <ng-container *ngFor="let item of items">
    <div *ngIf="item.kind === 'title'" class="context-menu-title">{{ item.label }}</div>

    <div *ngIf="item.kind === 'divider'" class="context-menu-divider"></div>

    <button *ngIf="item.kind === 'action'"
      type="button"
      class="context-menu-item"
      [class.context-menu-danger]="item.danger"
      [attr.aria-disabled]="item.disabled ? 'true' : null"
      role="menuitem"
      (click)="!item.disabled && action.emit(item.id)">
      <ng-container [ngSwitch]="item.id">
        <lucide-angular *ngSwitchCase="'cut'" name="scissors" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'copy'" name="copy" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'paste'" name="clipboard-paste" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'moveUp'" name="arrow-up" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'moveDown'" name="arrow-down" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'customMove'" name="move" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'insertAbove'" name="plus" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'insertBelow'" name="plus" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'clear'" name="x" [size]="14" aria-hidden="true"></lucide-angular>
        <lucide-angular *ngSwitchCase="'delete'" name="trash-2" [size]="14" aria-hidden="true"></lucide-angular>
      </ng-container>
      {{ item.label }}
    </button>
  </ng-container>
</div>
